/**
 * Generated runtime TestId mirror for frontend/src/pages/FunctionGroupDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const FunctionGroupDetailTestIds = {
  apEmptyState: "ap-empty-state",
  apWarning100: "ap-warning-100",
  btnRetryAp: "btn-retry-ap",
  cardFunctionGroupDetails: "card-function-group-details",
  cardTitleAttributes: "card-title-attributes",
  colCode: "col-code",
  colEnvironment: "col-environment",
  colName: "col-name",
  colResource: "col-resource",
  colRiskLevel: "col-risk-level",
  colStatus: "col-status",
  fgAccessProfilesCard: "fg-access-profiles-card",
  functionGroupDetailPage: "function-group-detail-page",
  apRow: (ap_accessProfile_id: string) => `ap-row-${ap_accessProfile_id}`,
  apRowPrefix: () => "ap-row-" as TestIdPrefix,
  apStatus: (ap_accessProfile_id: string) => `ap-status-${ap_accessProfile_id}`,
  apStatusPrefix: () => "ap-status-" as TestIdPrefix,
  linkAp: (ap_accessProfile_id: string) => `link-ap-${ap_accessProfile_id}`,
  linkApPrefix: () => "link-ap-" as TestIdPrefix
} as const;
